export default __webpack_public_path__ + "static/media/pizza-1.8e3e9966.jpg";